module.exports = __webpack_public_path__ + "img/thumbnail_AfricanLeopard_m_normal.ecdd1fe9.png";